import { render, staticRenderFns } from "./account-mfa.vue?vue&type=template&id=6a4b98a4&scoped=true&"
import script from "./account-mfa.vue?vue&type=script&lang=js&"
export * from "./account-mfa.vue?vue&type=script&lang=js&"
import style0 from "./account-mfa.vue?vue&type=style&index=0&id=6a4b98a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4b98a4",
  null
  
)

export default component.exports